import { useEffect, type ReactElement } from 'react'
import { GlobalHeader } from '../../components/stationPage/GlobalHeader'

/**
 * Private QA fixture for Playwright snapshots of the station-page
 * template header (TASK-699, Figma 8597:44779).
 *
 * URL contract: /__visual/station-page-header
 *
 * Light theme only — the template's dark variant has no Figma node
 * yet. `visual-fixture-active` neutralises the map SPA's JS-sized
 * absolute `#root` (see index.css) so the header spans the real
 * viewport width instead of a shrink-to-fit box.
 *
 * Dev/QA only — excluded from robots.txt (`Disallow: /__visual/`).
 */
export function StationPageHeaderVisualFixture(): ReactElement {
  useEffect(() => {
    const html = document.documentElement
    html.classList.add('visual-fixture-active')
    return () => {
      html.classList.remove('visual-fixture-active')
    }
  }, [])

  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <GlobalHeader locale="en" stationName="Baker Street" />
    </div>
  )
}
